// extracted by mini-css-extract-plugin
export default {"detailMain":"ContractDetailPage_detailMain__nana0"};